import { PUBLIC_HOME, isNative } from "@/lib/native";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import CelestialBackground from "@/components/CelestialBackground";
import SiteMenu from "@/components/SiteMenu";

export const SUPPORT_EMAIL = "support@astralogico.com";

export default function LegalShell({ kicker, title, updated, testId, children, path, docTitle }) {
  const navigate = useNavigate();
  const back = () => (window.history.length > 1 ? navigate(-1) : navigate(PUBLIC_HOME));
  useEffect(() => {
    if (!path) return undefined;
    const prev = document.title;
    document.title = docTitle || `${title} · Astra`;
    const canon = document.head.querySelector('link[rel="canonical"]') || document.head.appendChild(Object.assign(document.createElement("link"), { rel: "canonical" }));
    canon.href = `https://astralogico.com${path}`;
    return () => { document.title = prev; canon.remove(); };
  }, [path, title, docTitle]);
  return (
    <div className={`app-shell relative text-starlight ${isNative ? "" : "wide-desktop"}`} data-testid={testId}>
      <CelestialBackground />
      <div className="relative z-10 pb-16">
        <header className="sticky top-0 z-40 safe-top box-content h-16 backdrop-blur-xl bg-[#04060B]/85 border-b border-[#D4AF37]/20 px-4 flex items-center gap-3">
          <SiteMenu />
          <button data-testid={`${testId}-back`} onClick={back} aria-label="Back" className="text-[#A7B0C0] hover:text-starlight">
            <ArrowLeft size={20} />
          </button>
          <div className="flex items-center gap-2">
            <img src="/astra-mark-128.png" alt="" aria-hidden="true" className="w-9 h-9" />
            <span className="font-display text-lg tracking-[0.3em]">ASTRA</span>
          </div>
        </header>
        <div className={`px-6 pt-6 fade-up ${isNative ? "" : "lg:max-w-3xl lg:mx-auto lg:pt-12"}`}>
          <p className="text-[11px] uppercase tracking-[0.3em] gold-text mb-1">{kicker}</p>
          <h1 className="text-3xl font-light mb-2">{title}</h1>
          {updated && <p className="text-sm text-[#A7B0C0] mb-6">Last updated: {updated}</p>}
          <div className="space-y-6 text-base leading-relaxed text-[#D6D0C5]">{children}</div>
        </div>
      </div>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-xl text-starlight mb-2">{title}</h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
}

export function MailLink({ subject }) {
  return (
    <a data-testid="support-email-link" href={`mailto:${SUPPORT_EMAIL}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`} className="gold-text underline underline-offset-4">
      {SUPPORT_EMAIL}
    </a>
  );
}
